<script lang="ts" setup>
import { type FragmentType, graphql } from '@/gql';
import AppMarkdown from 'theme/components/atoms/AppMarkdown.vue';
import SimplePageContainer from 'theme/components/molecules/SimplePageContainer.vue';
import SimplePageHeading from 'theme/components/molecules/SimplePageHeading.vue';

const props = defineProps<{
  term: FragmentType<typeof TermOfServiceTemplateTermRevisionFragment>;
}>();

const TermOfServiceTemplateTermRevisionFragment = graphql(`
  fragment TermOfServiceTemplateTermRevision on TermRevision {
    id
    title
    body
  }
`);

const termObj = useComputedFragment(
  TermOfServiceTemplateTermRevisionFragment,
  () => props.term
);
</script>

<template>
  <SimplePageContainer>
    <SimplePageHeading :title="termObj.title" />
    <AppMarkdown :class="$style.container__content" :body="termObj.body" />
  </SimplePageContainer>
</template>

<style lang="scss" module>
.container {
  &__content {
    &:nth-child(n + 2) {
      margin-top: 48px;
    }
  }
}
</style>
